import React from 'react';

const PrintableShiftReport = React.forwardRef(({ rows }, ref) => {
  const renderData = () => {
    const headers = () => [
      'Fecha Asignación Turno',
      'Turno Asignado',
      'Extensión del Turno',
      'Asignación de Nuevo Turno',
      'Inicio del turno',
      'Nuevo Turno',
      'Extensión del Nuevo Turno',
      'Solicitante',
      'Observaciones'
    ];

    return (
      <div
        className="table_to_print"
        ref={ref}
        style={{
          margin: '0 auto',
          maxWidth: '800px',
          padding: '20px'
        }}
      >
        <h2 className="mt-2">Reporte de modificación de turnos</h2>
        <table border="1">
          <thead>
            <tr>
              <td>Empresa: {rows[0]?.company_name}</td>
            </tr>
            <tr>
              <td>Rut: {rows[0]?.company_national_id}</td>
            </tr>
            <tr>
              <td>
                Rango seleccionado de fechas: {rows[0]?.date_to} a {rows[0]?.date_from}
              </td>
            </tr>
          </thead>
        </table>
        <br />
        {rows &&
          rows.map(log => (
            <>
              <div style={{ marginBottom: '40px' }}>
                <table border="1">
                  <thead style={{ backgroundColor: '#EBEBEB' }}>
                    <tr>
                      <td style={{ textAlign: 'left' }} colSpan="4">
                        {log.full_name}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: 'left' }} colSpan="4">
                        Rut: {log.national_identification}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: 'left' }} colSpan="4">
                        Lugar de Prestación Servicio: {log.branch_offices_name}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: 'left' }} colSpan="4">
                        Banda Horaria: {log.is_article_27}
                      </td>
                    </tr>
                    <tr>
                      {headers().map(header => (
                        <th className="text-center align-middle">{header}</th>
                      ))}
                    </tr>
                  </thead>
                  {log.shift_log.length === 0 ? (
                    <tbody>
                      <tr>
                        <td colSpan="6" style={{ textAlign: 'center' }}>
                          Sin cambios o modificaciones de turnos en el periodo consultado
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    log.shift_log.map(shiftLog => (
                      <tbody>
                        <tr>
                          <td className="text-center align-middle">{shiftLog.original_shift_date}</td>
                          <td style={{ textAlign: 'left' }}>{shiftLog.original_turn_name}</td>
                          <td className="text-center align-middle">{shiftLog.original_shift_extension}</td>
                          <td className="text-center align-middle">{shiftLog.new_shift_date}</td>
                          <td className="text-center align-middle">{shiftLog.new_shift_start_date}</td>
                          <td style={{ textAlign: 'left' }}>{shiftLog.new_turn_name}</td>
                          <td className="text-center align-middle">{shiftLog.new_shift_extension}</td>
                          <td className="text-center align-middle">{shiftLog.solicitor}</td>
                          <td className="text-center align-middle">{shiftLog.observatio}</td>
                        </tr>
                      </tbody>
                    ))
                  )}
                </table>
              </div>
              <br />
            </>
          ))}
      </div>
    );
  };

  return <>{renderData()}</>;
});

export default PrintableShiftReport;
